import { useTranslation } from 'next-i18next'
import AffiliatePartners from './AffiliatePartners'
import Legal from './Legal'
import PaymentPartners from './PaymentPartners'
import { Logo } from '../header/Logo'
import { CurrencySelector } from '../common/CurrencySelector'
import { LanguageSelector } from '../common/LanguageSelector'

const Footer = () => {
  const { t } = useTranslation('common')

  return (
    <footer className="bg-white w-full z-50 mt-12">
      {/* <div
        style={{ width: '95vw', height: '1px' }}
        className="border rounded-full mx-auto my-24"
      ></div> */}
      <div className="max-w-custom-lg mx-0 xs:mx-auto px-3 md:px-6 lg:px-8 w-full flex flex-col items-stretch justify-start m-auto gap-12">
        <AffiliatePartners />
        <Legal />
        <PaymentPartners />
        <div className="grid grid-cols-1 md:grid-cols-3 items-center w-full gap-8">
          <div className="hidden md:flex justify-center items-center">
            <span className="mr-2 text-sm text-neutral">{t('language')}:</span>
            <LanguageSelector />
          </div>
          <div className="flex flex-col items-center justify-center">
            <Logo />
            <div className="text-xs mt-4 text-neutral">{t('with-love')}</div>
            <div className="md:hidden flex items-center mt-12">
              <span className="mr-2 text-sm text-neutral">
                {t('language')}:
              </span>
              <LanguageSelector />
            </div>
          </div>
          <div className="flex justify-center items-center">
            <span className="mr-2 text-sm text-neutral">{t('currency')}:</span>
            <CurrencySelector />
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
